import React from 'react';
import './header.scss'; 
import logo  from './../../assets/images/logo.png'


export default () => (
    <div className='header'>
        <img src={logo} className='logo' />
    </div>
)
